export default __webpack_public_path__ + "static/media/ceramics.a1fd6cbf.jpg";